export function compareByDateDesc(a: Date, b: Date): number {
  return b.valueOf() - a.valueOf();
}

export function compareByDateAsc(a: Date, b: Date): number {
  return a.valueOf() - b.valueOf();
}

/**
 * From a list of items with a `dueAt` date, return the most relevant one:
 * - Prefer the earliest upcoming (future) due date.
 * - If all are overdue, return the most recent (least overdue).
 */
export function findNextDue<T extends { dueAt: Date }>(
  items: T[],
): T | undefined {
  if (items.length === 0) return;

  const now = new Date();
  const upcoming = items.filter((i) => i.dueAt >= now);

  if (upcoming.length > 0) {
    return upcoming.toSorted((a, b) => compareByDateAsc(a.dueAt, b.dueAt))[0];
  }

  return items.toSorted((a, b) => compareByDateDesc(a.dueAt, b.dueAt))[0];
}
